// Firebase Firestore setup for persistent PDF storage
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDoc, getDocs, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';

// Your Firebase config (you already have this)
const firebaseConfig = {
    apiKey: "AIzaSyCje6mIkoz5m_bTFzIMTFyZ9BTElx1It50",
    authDomain: "study-ai-52447.firebaseapp.com",
    projectId: "study-ai-52447",
    storageBucket: "study-ai-52447.firebasestorage.app",
    messagingSenderId: "434195758797",
    appId: "1:434195758797:web:3d190e46fd3e11494b7384",
    measurementId: "G-HFE2KVZRV0"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);


// User Document Structure
export const saveUserDocument = async (userId, documentData) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const documentsRef = collection(userDocRef, 'documents');
    
    // Add document to user's subcollection
    const docRef = await addDoc(documentsRef, {
      ...documentData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    
    return docRef.id;
  } catch (error) {
    console.error('Error saving document:', error);
    throw error;
  }
};

// Get user's documents
export const getUserDocuments = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const documentsRef = collection(userDocRef, 'documents');
    const snapshot = await getDocs(documentsRef);
    
    const documents = [];
    snapshot.forEach((doc) => {
      documents.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return documents;
  } catch (error) {
    console.error('Error getting documents:', error);
    throw error;
  }
};

// Update document metadata
export const updateDocumentMetadata = async (userId, documentId, updates) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const documentRef = doc(userDocRef, 'documents', documentId);
    
    await updateDoc(documentRef, {
      ...updates,
      updatedAt: new Date()
    });
  } catch (error) {
    console.error('Error updating document:', error);
    throw error;
  }
};

// Delete document
export const deleteUserDocument = async (userId, documentId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const documentRef = doc(userDocRef, 'documents', documentId);
    
    await deleteDoc(documentRef);
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

// Save user quiz to Firebase
export const saveUserQuiz = async (userId, quizData) => {
  try {
    console.log('💾 Saving quiz for user:', userId);
    
    // Create user document and quizzes collection automatically
    const userDocRef = doc(db, 'users', userId);
    const quizzesRef = collection(userDocRef, 'quizzes');
    
    // Add quiz with timestamps
    const quizRef = await addDoc(quizzesRef, {
      ...quizData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    
    console.log('✅ Quiz saved successfully with ID:', quizRef.id);
    return quizRef.id;
  } catch (error) {
    console.error('❌ Failed to save quiz:', error.message);
    throw error;
  }
};

// Save user flashcard to Firebase
export const saveUserFlashcard = async (userId, flashcardData) => {
  try {
    console.log('💾 Saving flashcards for user:', userId);
    
    // Create user document and flashcards collection automatically
    const userDocRef = doc(db, 'users', userId);
    const flashcardsRef = collection(userDocRef, 'flashcards');
    
    // Add flashcards with timestamps
    const flashcardRef = await addDoc(flashcardsRef, {
      ...flashcardData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    
    console.log('✅ Flashcards saved successfully with ID:', flashcardRef.id);
    return flashcardRef.id;
  } catch (error) {
    console.error('❌ Failed to save flashcards:', error.message);
    throw error;
  }
};

// Get user's saved quizzes
export const getUserQuizzes = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const quizzesRef = collection(userDocRef, 'quizzes');
    const snapshot = await getDocs(quizzesRef);
    
    const quizzes = [];
    snapshot.forEach((doc) => {
      quizzes.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return quizzes;
  } catch (error) {
    console.error('Error getting user quizzes:', error);
    throw error;
  }
};

// Get user's saved flashcards
export const getUserFlashcards = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const flashcardsRef = collection(userDocRef, 'flashcards');
    const snapshot = await getDocs(flashcardsRef);
    
    const flashcards = [];
    snapshot.forEach((doc) => {
      flashcards.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return flashcards;
  } catch (error) {
    console.error('Error getting user flashcards:', error);
    throw error;
  }
};

// Fetch quiz data from backend API
export const fetchQuizData = async (userId, quizId) => {
  try {
    const response = await fetch(`https://celebrated-charisma-production-5701.up.railway.app/my_quizzes?user_id=${userId}`, {
      method: 'GET',
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch quiz data');
    }
    
    const data = await response.json();
    console.log('Raw quiz data:', data);
    
    if (data && Array.isArray(data.quizzes)) {
      // Find the specific quiz by ID
      const targetQuiz = data.quizzes.find(quizSet => quizSet.id === quizId);
      
      if (!targetQuiz) {
        throw new Error('Quiz not found');
      }
      
      // Parse the quiz content using the same logic as Dashboard
      const rawContent = targetQuiz.quiz;
      console.log('Raw quiz content to parse:', rawContent);
      
      // Try to parse the quiz content with pattern that handles **Correct Answer:** and **Explanation:**
      let questionPattern = /(\d+)\.\s*\*\*(.*?)\*\*\s*A\)\s*(.*?)\s*B\)\s*(.*?)\s*C\)\s*(.*?)\s*D\)\s*(.*?)\s*\*\*Correct Answer:\*\*\s*[A-D]\)\s*(.*?)\s*\*\*Explanation:\*\*\s*(.*?)(?=\d+\.|$)/gis;
      let matches = [...rawContent.matchAll(questionPattern)];
      
      // Pattern 2: If first pattern fails, try without bold formatting
      if (matches.length === 0) {
        questionPattern = /(\d+)\.\s*(.*?)\s*A\)\s*(.*?)\s*B\)\s*(.*?)\s*C\)\s*(.*?)\s*D\)\s*(.*?)\s*Correct Answer:\s*[A-D]\)\s*(.*?)\s*Explanation:\s*(.*?)(?=\d+\.|$)/gis;
        matches = [...rawContent.matchAll(questionPattern)];
      }
      
      // Pattern 3: Try with different line break handling
      if (matches.length === 0) {
        questionPattern = /(\d+)\.\s*\*\*(.*?)\*\*\n\s*A\)\s*(.*?)\n\s*B\)\s*(.*?)\n\s*C\)\s*(.*?)\n\s*D\)\s*(.*?)\n\s*\*\*Correct Answer:\*\*\s*[A-D]\)\s*(.*?)\n\s*\*\*Explanation:\*\*\s*(.*?)(?=\n\s*\d+\.|$)/gis;
        matches = [...rawContent.matchAll(questionPattern)];
      }
      
      console.log('Parsing matches found:', matches.length);
      if (matches.length > 0) {
        console.log('First match groups:', matches[0]);
        console.log('Question:', matches[0][2]);
        console.log('Options:', [matches[0][3], matches[0][4], matches[0][5], matches[0][6]]);
        console.log('Correct Answer:', matches[0][8]);
        console.log('Explanation:', matches[0][9]);
      }
      
      let questions = [];
      
      if (matches.length > 0) {
        questions = matches.map((match, index) => {
          // Clean the options to remove any explanation text that might have leaked in
          const cleanOptions = [
            match[3]?.trim(),
            match[4]?.trim(),
            match[5]?.trim(),
            match[6]?.trim()
          ].filter(Boolean);
          
          // Get the explanation from the parsed content
          let explanation = "Generated from document content. This explanation provides context for the correct answer based on the source material.";
          if (match[9] && match[9].trim()) {
            explanation = match[9].trim();
          } else if (match[8] && match[8].trim()) {
            explanation = match[8].trim();
          }
          
          return {
            id: `${targetQuiz.id}_${index}`,
            question: match[2]?.trim(),
            options: cleanOptions,
            correct_answer: 0, // Default to first option as correct
            explanation: explanation
          };
        });
      } else {
        // If parsing fails, create a simple question from the raw content
        console.log('Parsing failed, creating fallback quiz structure');
        questions = [{
          id: `${targetQuiz.id}_fallback`,
          question: "Generated Quiz Content",
          options: ["View raw content below"],
          correct_answer: 0,
          explanation: rawContent,
          is_raw_content: true
        }];
      }
      
      return {
        id: targetQuiz.id,
        title: targetQuiz.document_name || "Generated Quiz",
        document_name: targetQuiz.document_name,
        questions: questions,
        total_questions: questions.length,
        created_at: targetQuiz.created_at
      };
    } else {
      throw new Error('No quiz data found');
    }
  } catch (error) {
    console.error('Error fetching quiz data:', error);
    throw error;
  }
};
